<template>
  <div>
    <div>
      <label class="ts-mb-0">{{ $t('productProfile.location') }}</label>
      <a-select
        v-model="model.location"
        mode="multiple"
        :maxTagCount="10"
        :options="locationList"
        showSearch
        :filterOption="
          (input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
        "
        class="ts-w-full"
      ></a-select>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'location',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    locationList() {
      return this.$store.state.product.profile.locations.map(el => ({
        value: el.location_id,
        label:
          (el.location_name_kh ? el.location_name_kh + '-' : '') +
          el.location_name_en
      }))
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
